import React from 'react';

export const Footer= ({
  selected,
  handleSelected
}: {
  selected: string;
  handleSelected: (name: string) => void;
}):React.ReactElement => {
  return (
    <div className='
      fixed bottom-0 left-0 w-full
      p-4 pb-6 bg-white border-t-2'
    >
      <div className='grid grid-cols-4'>
        <div
          className='flex justify-center'
          onClick={() => handleSelected('food')}
        >
          <p className={`${selected === 'food' && 'font-extrabold text-yellow-500'} tracking-wide`}>
            Food
          </p>
        </div>
        <div
          className='flex justify-center'
          onClick={() => handleSelected('drinks')}
        >
          <p className={`${selected === 'drinks' && 'font-extrabold text-yellow-500'} tracking-wide`}>
            Drinks
          </p>
        </div>
        <div
          className='flex justify-center'
          onClick={() => handleSelected('extras')}
        >
          <p className={`${selected === 'extras' && 'font-extrabold text-yellow-500'} tracking-wide`}>
            Extras
          </p>
        </div>
        <div
          className='flex justify-center'
          onClick={() => handleSelected('announcements')}
        >
          <p className={`${selected === 'announcements' && 'font-extrabold text-yellow-500'} tracking-wide`}>
            Announcements
          </p>
        </div>
      </div>
    </div>
  );
};
